/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Reset_Aria_LabelInputs */

const en_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset all video filters`)
};

const fr_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinitialiser tous les filtres video`)
};

const de_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Videofilter zurücksetzen`)
};

const it_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta tutti i filtri video`)
};

const ru_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить все видеофильтры`)
};

const es_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer todos los filtros de vídeo`)
};

const zh_cn2_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置所有视频滤镜`)
};

const ja_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのビデオフィルターをリセット`)
};

const hi_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी वीडियो फ़िल्टर रीसेट करें`)
};

const pt_pt2_video_filters_reset_aria_label = /** @type {(inputs: Video_Filters_Reset_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir todos os filtros de vídeo`)
};

/**
* | output |
* | --- |
* | "Reset all video filters" |
*
* @param {Video_Filters_Reset_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_reset_aria_label = /** @type {((inputs?: Video_Filters_Reset_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Reset_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_reset_aria_label(inputs)
	if (locale === "de") return de_video_filters_reset_aria_label(inputs)
	if (locale === "it") return it_video_filters_reset_aria_label(inputs)
	if (locale === "ru") return ru_video_filters_reset_aria_label(inputs)
	if (locale === "es") return es_video_filters_reset_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_reset_aria_label(inputs)
	if (locale === "ja") return ja_video_filters_reset_aria_label(inputs)
	if (locale === "hi") return hi_video_filters_reset_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_reset_aria_label(inputs)
	return en_video_filters_reset_aria_label(inputs)
});